// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2588636b","122":"c5dc51e0","249":"3a83b2ab","523":"e67b090e","587":"8feb96f8","746":"bcc05df6"}[chunkId] + ".chunk.js";
};